import {Vue} from '../../addiesaas'

import {enUS} from './custom-pluralize'

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const { locale, translations = {} } = window.addiesaas.config

const {
  frontend:{
    dateTimeFormats = translations.dateTimeFormats || {},
    numberFormats = translations.numberFormats || {}
  }  = {}
} = translations

const i18n = window.addiesaas.i18n = new VueI18n({
  locale,
  fallbackLocale: 'en-US',
  silentTranslationWarn: true,
  dateTimeFormats: {
    [locale]: dateTimeFormats
  },
  numberFormats: {
    [locale]: numberFormats
  },
  messages: {
    [locale]: translations
  },
  pluralizationRules: {
    'en-US': enUS
  }
})

Vue.prototype.$$locale = locale

export default i18n
